import { userAuth } from '../enums';
import { BaseModel } from './base';

export type AuthorizedEmail = userAuth & BaseModel & {
    email: string;
};

export const newAuthorizedEmail: AuthorizedEmail = {
    id: 0,
    email: '',
    franchiseId: null,
    isAdmin: null
};
